export const AUTH_TOKEN = 'auth-token'
export const POLL_INTERVAL = 10000


// WEBPACK FOOTER //
// ./src/utils/constants.js